var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NetworkErrorPayload } from "../../../errors/NetworkError";
import { UnknownErrorPayload } from "../../../errors/UnknownError";
import { State } from "../../../hooks/useUseCase";
import { createSelectedNotes } from "../../../models/NoteSelect/SelectedNotes";
import { OpenedNoteSelectDialogPayload } from "./usecases/OpenNoteSelectDialogUseCase";
import { SelectedNotePayload } from "./usecases/SelectNoteUseCase";
import { UnselectedNotePayload } from "./usecases/UnselectNoteUseCase";
import { ClosedNoteSelectDialogPayload } from "./usecases/CloseNoteSelectDialogUseCase";
import { StartedLoadingPayload } from "./usecases/payload/StartedLoadingPayload";
import { FinishedLoadingPayload } from "./usecases/payload/FinishedLoadingPayload";
import { FetchedNotesPayload } from "./usecases/FetchNoteUseCase";
import { ChangedOwnerNameVisibilityPayload } from "./usecases/ChangeOwnerNameVisibilityUseCase";
import { ChangedFlagPageVisibilityPayload } from "./usecases/ChangeFlagPageVisibilityUseCase";
import { ChangedPaginationPayload } from "./usecases/ChangePaginationUseCase";
import { ClosedAlertPayload } from "./usecases/CloseAlertUseCase";
var NOTES_PER_PAGE = 8;
var defaultPagination = {
    totalCount: 0,
    page: 1,
    lastPage: 0,
};
var NoteSelectDialogState = /** @class */ (function (_super) {
    __extends(NoteSelectDialogState, _super);
    function NoteSelectDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notes = [];
        _this.selectedNotes = createSelectedNotes();
        _this.pagination = defaultPagination;
        _this.isLoading = false;
        _this.showOwnerName = true;
        _this.showFlagPage = false;
        _this.isAssignmentOwner = false;
        _this.requiredAlert = undefined;
        return _this;
    }
    Object.defineProperty(NoteSelectDialogState.prototype, "selectedNoteId", {
        get: function () {
            return this.selectedNotes.notes.map(function (note) { return note.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoteSelectDialogState.prototype, "currentNotes", {
        get: function () {
            var firstIndex = (this.pagination.page - 1) * NOTES_PER_PAGE;
            var lastIndex = Math.min(firstIndex + NOTES_PER_PAGE, this.pagination.totalCount);
            return this.notes.slice(firstIndex, lastIndex);
        },
        enumerable: false,
        configurable: true
    });
    NoteSelectDialogState.prototype.reduce = function (payload) {
        if (payload instanceof OpenedNoteSelectDialogPayload) {
            this.pagination = defaultPagination;
            this.selectedNotes = createSelectedNotes('multipule');
            this.selectedNotes.initialize([]);
            this.showOwnerName = true;
            this.showFlagPage = false;
        }
        if (payload instanceof FetchedNotesPayload) {
            this.notes = payload.notes;
            this.pagination = {
                totalCount: payload.notes.length,
                page: 1,
                lastPage: Math.ceil(payload.notes.length / NOTES_PER_PAGE),
            };
            this.isLoading = false;
            this.isAssignmentOwner = payload.isAssignmentOwner;
            if (!payload.isAssignmentOwner) {
                this.showOwnerName = true;
            }
        }
        if (payload instanceof UnselectedNotePayload) {
            this.selectedNotes.unselect(payload.note);
        }
        if (payload instanceof SelectedNotePayload) {
            this.selectedNotes.select(payload.note);
        }
        if (payload instanceof ClosedNoteSelectDialogPayload) {
            this.selectedNotes.clear();
        }
        if (payload instanceof StartedLoadingPayload) {
            this.isLoading = true;
        }
        if (payload instanceof FinishedLoadingPayload) {
            this.isLoading = false;
        }
        if (payload instanceof ChangedOwnerNameVisibilityPayload) {
            this.showOwnerName = payload.showOwnerName;
        }
        if (payload instanceof ChangedFlagPageVisibilityPayload) {
            this.showFlagPage = payload.showFlagPage;
        }
        if (payload instanceof ChangedPaginationPayload) {
            this.pagination.page = payload.nextPage;
        }
        if (payload instanceof NetworkErrorPayload || payload instanceof UnknownErrorPayload) {
            this.requiredAlert = payload.error;
        }
        if (payload instanceof ClosedAlertPayload) {
            this.requiredAlert = undefined;
        }
    };
    return NoteSelectDialogState;
}(State));
export { NoteSelectDialogState };
export var initialNoteSelectDialogState = new NoteSelectDialogState();
